import { useAuth } from '../auth'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Field, Formik, getIn } from 'formik'
import yup from '../utils/validations'
import { VERSION } from '../constants'
import { useState } from 'react'

const schema = yup.object().shape({
  email: yup.string().email().required().label('Email'),
  password: yup.string().required().label('Password'),
})

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const { performLogin, loginError } = useAuth()
  const [isSubmitting, setIsSubmitting] = useState(false)

  return (
    <div className="d-flex h-100 bg-primary guest-page">
      <div className="w-50 bg-primary h-100 d-flex flex-column justify-content-center align-items-center guest-brand">
        <img
          src="/statik/main/LOGO.svg"
          height={40}
          alt=""
          className="d-block mb-2 me-2"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
      </div>
      <div
        className="w-50 d-flex flex-column justify-content-center align-items-center bg-white guest-panel"
        style={{
          borderRadius: '20px 0 0 20px',
        }}
      >
        <div className="w-50 guest-content">
          <h1 className="heading-h1">LOGIN</h1>
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values) => {
              setIsSubmitting(true)
              performLogin(values).finally(() => {
                setIsSubmitting(false)
              })
            }}
          >
            {({ handleSubmit, touched, errors }) => (
              <form onSubmit={handleSubmit}>
                <div style={{ marginTop: 40, marginBottom: 40 }}>
                  <div>
                    <div className="form-group">
                      <label htmlFor="email" className="label-m text-body-secondary">
                        Email
                      </label>
                      <Field
                        className={
                          'form-control' + (getIn(errors, 'email') && getIn(touched, 'email') ? ' is-invalid' : '')
                        }
                        type="email"
                        name="email"
                        id="email"
                        autoComplete="username"
                        autoCapitalize="none"
                      />
                      {getIn(errors, 'email') && getIn(touched, 'email') && (
                        <div className="text-danger">{getIn(errors, 'email')}</div>
                      )}
                    </div>
                    <div className="form-group mt-3">
                      <label htmlFor="password" className="label-m text-body-secondary">
                        Password
                      </label>
                      <Field
                        type="password"
                        className={
                          'form-control' +
                          (getIn(errors, 'password') && getIn(touched, 'password') ? ' is-invalid' : '')
                        }
                        name="password"
                        id="password"
                        autoComplete="current-password"
                      />
                      {getIn(errors, 'password') && getIn(touched, 'password') && (
                        <div className="text-danger">{getIn(errors, 'password')}</div>
                      )}
                    </div>
                  </div>
                  <div className="mt-2 text-end">
                    <Link to="/password-dimenticata" className="text-danger no-link p-md">
                      Password dimenticata?
                    </Link>
                  </div>
                </div>
                <div>
                  {loginError && (
                    <div className="alert alert-danger mt-2 py-1">
                      {(loginError as any).non_field_errors?.join(',') || 'Credenziali non valide. Riprova.'}
                    </div>
                  )}
                </div>

                <Button
                  type="submit"
                  variant="secondary"
                  disabled={isSubmitting}
                  className="w-100 mt-2 text-white d-flex align-items-center justify-content-center"
                >
                  Accedi
                  {isSubmitting && <span className="spinner-border spinner-border-sm ms-2"></span>}
                </Button>
              </form>
            )}
          </Formik>
          <div className="text-center mt-4">Versione: {VERSION}</div>
        </div>
      </div>
    </div>
  )
}
